export default  {"src":"/_next/static/image/public/assets/icons/close-greyer.d182eea75a972dcd62dcec279d58d931.svg","height":15,"width":15};